import React from "react"

import ProjectHeaderComponent from "./project-header-component"
import PPIInvestmentProjectService from '../../../../service/sfp/ppi-investment-project-service';

class ProjectHeaderContainer extends React.Component {

    state = {
        submitting: false
    }

    render() {
        return (
            <ProjectHeaderComponent {...this.props} onToggleProject={this._handleToggleProject.bind(this)}/>
        )
    }

    _handleToggleProject() {
        this.props.onToggleProject(this.props.row.project)
        this.setState({submitting: true}, () => {
            PPIInvestmentProjectService.updatePPIInvestmentProject(this.props.row.project.id, {visible: this.props.row.project.visible})
                .then(this._resolveUpdateInvestmentProject.bind(this, event), this._rejectUpdateInvestmentProject)
        })
    }

    _rejectUpdateInvestmentProject = (error) => {
        this.props.actions.throwError(error)
        this.setState({error, submitting: false})
    }

    _resolveUpdateInvestmentProject = (
        /** @type {React.SyntheticEvent<Element>} */ event,
        /** @type {Object} */               response) => {
        this.setState({submitting: false}, () => {
            if (this.props.onProjectUpdated) {
                this.props.onProjectUpdated(response)
            }
        })
    }

}

export default ProjectHeaderContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/project-header-container.js